import { useEffect } from "react";
import Sidebar from "../../comman_page/Sidebar";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { Footer } from "../../../../../public/containers/footer/Footer";
import { customer_request_list } from "../../../../../Studio-Services/Studio_Services";
import { useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { ClientListTable } from "./ClientListTable";

export const Clientoflist = () => {

  const [array, setArray] = useState([]);
  const [loader, setLoader] = useState(false);
  const getClientList = async () => {
    const pid = { 'pageid': '1' };
    let abcd = [];
    setLoader(true);
    const resp = await customer_request_list(pid);
    if (resp) {
      resp.data.forEach((element) => {
        abcd.push({
          Name: (
            <>
              <Link to='/studio-customer-profile' state={{ id: element.id }} style={{ cursor: 'pointer' }}>
                <img className="img-fluid table_user" src={element.profile_img} alt='' />
                <span className="ps-4">{element.name}</span>
              </Link>
            </>
          ),
          myName: element.name,
          dob: element.date_of_birth ? moment(element.date_of_birth).format("DD MMM YYYY") : "",
          Email: element.myEmail,
          mobile: element.mobile,
          Age: element.age,
          Gender: element.gender,
          Start_Date: element.reg_date ? moment.unix(element.reg_date).format('DD-MMM-YYYY') : "",
          Status: element.user_status,
        });
      });
      setArray(abcd);
      setLoader(false);
    } else setArray(abcd);
    setLoader(false);
  };

  useEffect(() => {
    getClientList();
  }, []);


  return (
    <>
      {loader &&
        <div className='MainLoader'>
          <Spinner animation="border" role="status" className='Loader' />
        </div>
      }
      <div className="MainDashboard">
        <div className="MainLayout">
          <Row>
            <Sidebar />
            <Col>
              <div className="RightSide">
                <HeaderDashboard />
                <section className="addClient innerContent">
                  <div className="AddClientContent">
                    <Container fluid>
                      <Row className="mt-3 clinet-list-tab">
                        <Col>
                          <ClientListTable pre_data={array} />
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </section>
                <Footer />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
